/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { FaGithub, FaLinkedin, FaMedium } from "react-icons/fa";
import Typing from 'react-typing-animation';
import Aos from "aos";
import "aos/dist/aos.css";

function Main({ children, ...restProps }) {
  useEffect(() => {
    Aos.init({});
  
  }, [])
  return (
    <div className=" w-full bg-gray-800 border rounded-lg " >
      <div className=" md:py-1  w-full text-xl text-center items-center
        md:text-left flex flex-row justify-between bg-gray-700 rounded-t-lg px-2 md:px-4">
        <div className="text-green-500 font-medium px-0 md:px-1 text-base flex flex-row gap-2">
        <img src="/images/profile.jpg" 
                alt="Persons talking in a work setting." 
                className="object-cover  rounded-full mx-auto hidden md:block md:w-6"/>         
       <div> Hafiz<span className="text-white px-1">Mohammed</span></div>
        </div>
        <div className="text-sm text-gray-200 hidden md:block font-medium">Portfolio</div>
      <div className="flex flex-row">
          <div  data-aos="fade-left" data-aos-duration="1500">
          <a href="https://www.linkedin.com/in/hafiz-mohammed-45065160" 
         
         target="_blank"><FaLinkedin className="inline-block text-white hover:text-green-500 cursor-pointer  mx-2"  /></a>
          </div>
          <div     data-aos="fade-up" data-aos-duration="1500">
          <a href="https://hafizmohammed.medium.com"
           
          target="_blank">
              <FaMedium className="inline-block text-white hover:text-green-500 cursor-pointer mx-2"/>
              </a>
              </div>
              <div     data-aos="fade-right" data-aos-duration="1500">
          <a href="https://github.com/hafizMDM" 
           
          target="_blank" >
          <FaGithub className="inline-block text-white hover:text-green-500 cursor-pointer mx-2"/>
          </a>
          </div>
        </div>
      </div>
      <div className="flex flex-row shadow-lg hidden">
      <div className="p-2 bg-gray-800 text-white font-medium text-sm border-r border-gray-800 cursor-pointer shadow-lg">Portfolio</div>
      <div className="p-2 bg-gray-700 text-yellow-600 font-medium text-sm opacity-80 border-r border-gray-800 cursor-pointer shadow-lg">Skills</div>
      <div className="p-2 bg-gray-700 text-yellow-600 font-medium text-sm opacity-80 border-r border-gray-800 cursor-pointer shadow-lg">Projects</div>
    </div>
    <div
        className="flex flex-col md:flex-row  lg:flex-row sm:mx-auto py-2 justify-center px-4 md:py-12 mx-auto items-center" >
        <div className="py-6 md:py-8"    data-aos="zoom-in-right" data-aos-duration="600"> 
            <img src="/images/profile.jpg" 
                alt="Persons talking in a work setting." className="object-cover  rounded-full mx-auto w-48 md:w-56"/>
          
        </div>
        <div className="flex flex-col justify-center p-4 md:p-8  lg:p-16 lg:w-2/3 text-lg">
        <div className="bg-gray-800 p-4 rounded-lg" >
        <Typing speed={5} cursorClassName="text-green-500 font-bold">
            <h5 className="mb-3 text-3xl font-bold leading-none sm:text-4xl text-white">
              Hello, I'm   <span className="font-bold text-3xl md:text-5xl text-green-500">
             
                Hafiz </span> <span className="font-bold text-3xl md:text-5xl">
             Mohammed</span>
            </h5>
        
            <p className="py-2 mb-5 text-white  font-mono">
            <span className="font-bold text-xl md:text-2xl text-yellow-400">A Full stack developer </span>

             with awesome  
             <span className="font-bold text-xl md:text-2xl text-blue-300"> React JS, </span>  
             <span className="font-bold text-xl md:text-2xl text-blue-500"> React Native </span>   and 
             <span className="font-bold text-xl md:text-2xl text-purple-500"> .NET Core</span> skills.
            Expertise in
            <span className="font-bold text-xl md:text-2xl text-blue-200">  CyberSecurity, </span>
               solid product development experience, specialized in early stages of development for startups and the ability to thrive in a fast-paced environment, 
              looking to create world-class applications.
            </p>
           
        </Typing>
        </div>
      
        </div>
       
    </div>
   
    
</div>
  );
}

export default Main;